
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0e5497b8&scoped=true!stylus-loader!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Blocked.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Blocked.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0e5497b8!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Blocked.vue"),
  /* scopeId */
  "data-v-0e5497b8",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/Main/Blocked.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Blocked.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e5497b8", Component.options)
  } else {
    hotAPI.reload("data-v-0e5497b8", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Blocked.vue
// module id = 157
// module chunks = 0